// Menu selections for the "The Table" section. Each menu has sections of dishes.
// item: { t: title, d?: description }

export const MENUS = [
  {
    id: "flavours-of-spain",
    name: "Flavours of Spain",
    sections: [
      {
        title: "Starters",
        items: [
          { t: "Jamón Ibérico with Pan con Tomate" },
          { t: "Garlic King Prawns (Gambas al Ajillo)" },
          { t: "Andalusian Gazpacho with Cucumber & Olive Oil" },
        ],
      },
      {
        title: "Main Courses",
        items: [
          { t: "Slow-Cooked Iberian Pork Cheeks with Truffle Potato Purée" },
          { t: "Grilled Sea Bass with Saffron Potatoes & Seasonal Vegetables" },
          { t: "Seafood Paella with King Prawns, Mussels & Squid" },
        ],
      },
      {
        title: "Desserts",
        items: [
          { t: "Basque Burnt Cheesecake" },
          { t: "Traditional Torrija with Vanilla Ice Cream" },
          { t: "Crema Catalana" },
        ],
      },
    ],
  },
  {
    id: "canape-party",
    name: "Canapé Party",
    sections: [
      {
        title: "Canapés",
        items: [
          { t: "Smoked Salmon Mousse with Crème Fraîche, Lime & Dill on Blini" },
          { t: "Stilton and Quince Pâté on Fresh Sour Bread" },
          { t: "Mini Yorkshire Pudding Canapés with Horseradish Cream" },
        ],
      },
      {
        title: "Starters",
        items: [
          { t: "Mussels and Smoky Bacon in a Creamy White Wine Sauce" },
          { t: "Garlic Prawns served with Croutons" },
          { t: "Creamy Seafood Chowder" },
        ],
      },
      {
        title: "Mains",
        items: [
          { t: "Beef Wellington with Protos Red Wine Reduction", d: "Served with garlic-chive smashed new potatoes, tenderstem broccoli & Chantenay carrots" },
          { t: "Leg of Lamb Roulade with Rosemary Jus", d: "Served with roasted potatoes, French green beans & sautéed courgette" },
          { t: "Honey Garlic Glazed Salmon", d: "Served with tenderstem broccoli, new potatoes & a light lemon butter sauce" },
        ],
      },
      {
        title: "Desserts",
        items: [
          { t: "Vanilla Crème Brûlée" },
          { t: "Strawberry Panna Cotta" },
          { t: "Blueberry Cheesecake" },
        ],
      },
    ],
  },
  {
    id: "classic-british-bbq",
    name: "Classic British BBQ",
    sections: [
      {
        title: "Meats & Grill",
        items: [
          { t: "Cumberland or Lincolnshire sausages, or pork & apple sausages" },
          { t: "Beef burgers with mature cheddar, caramelised onions and brioche buns" },
          { t: "Honey & mustard chicken drumsticks" },
          { t: "Pork chops glazed with cider and rosemary" },
          { t: "Lamb kebabs with mint and yoghurt" },
        ],
      },
      {
        title: "Side Dishes",
        items: [
          { t: "Coleslaw (shredded cabbage and carrot in creamy mayo)" },
          { t: "Potato salad with chives and hard-boiled egg" },
          { t: "Baked beans (sweet and smoky)" },
          { t: "Grilled halloumi with cherry tomatoes" },
          { t: "Mixed leaf salad with English mustard vinaigrette" },
        ],
      },
      {
        title: "Breads & Extras",
        items: [
          { t: "Burger and hot dog buns" },
          { t: "Onion bread or British-style focaccia" },
          { t: "Pickles, chutneys and pickled onions" },
        ],
      },
      {
        title: "Sauces & Condiments",
        items: [
          { t: "HP-style brown sauce" },
          { t: "English mustard (hot and punchy)" },
          { t: "Ketchup & mayonnaise" },
          { t: "Smoky BBQ sauce" },
          { t: "Mint yoghurt sauce" },
        ],
      },
    ],
  },
  {
    id: "grazing-table",
    name: "Grazing Table — British & Mediterranean Fusion",
    sections: [
      {
        title: "Cheese & Charcuterie Selection",
        items: [
          { t: "British Cheeses", d: "Mature Cheddar, Stilton, Somerset Brie" },
          { t: "Mediterranean Cheeses", d: "Manchego, halloumi bites, feta marinated with herbs & olive oil" },
          { t: "Charcuterie", d: "Jamón Serrano, Prosciutto di Parma, Chorizo Ibérico, Salami Milano" },
          { t: "Served with", d: "Quince paste, grapes, figs, cornichons and assorted nuts" },
        ],
      },
      {
        title: "Breads & Dips",
        items: [
          { t: "Artisan breads", d: "Focaccia, grissini, seeded crackers, mini pita breads" },
          { t: "Hummus with paprika and olive oil" },
          { t: "Roasted red pepper & almond romesco" },
          { t: "British-style smoked mackerel pâté" },
          { t: "Tzatziki with cucumber and dill" },
        ],
      },
      {
        title: "Seafood Selection",
        items: [
          { t: "King prawns with lemon aioli" },
          { t: "Smoked salmon with capers and shallots on rye crisps" },
          { t: "Mini crab tartlets with citrus crème fraîche" },
          { t: "Marinated anchovies and olives with orange zest" },
        ],
      },
      {
        title: "Vegetarian & Fresh Bites",
        items: [
          { t: "Roasted Mediterranean vegetables (courgette, pepper, aubergine)" },
          { t: "Cherry tomato, mozzarella and basil skewers" },
          { t: "Marinated artichokes & sun-dried tomatoes" },
          { t: "Mini falafel with tahini dip" },
          { t: "Seasonal crudités: carrot, cucumber, celery, radish" },
        ],
      },
      {
        title: "Meat & Savoury Bites",
        items: [
          { t: "Mini Yorkshire puddings with roast beef and horseradish cream" },
          { t: "Lamb koftas with mint yoghurt" },
          { t: "Chicken skewers with lemon & oregano glaze" },
          { t: "Sausage rolls with caramelised onion chutney" },
        ],
      },
      {
        title: "Sweet Grazing Corner",
        items: [
          { t: "Mini scones with clotted cream and jam" },
          { t: "Lemon drizzle cake bites" },
          { t: "Mediterranean almond cake (Tarta de Santiago style)" },
          { t: "Chocolate truffles with sea salt" },
          { t: "Fresh fruit platter: grapes, berries, melon, figs" },
        ],
      },
    ],
  },
  {
    id: "italian-4-course",
    name: "Italian 4 Course",
    sections: [
      {
        title: "Antipasti — Starters",
        items: [
          { t: "Bruschetta al Pomodoro", d: "Toasted rustic bread topped with ripe tomatoes, basil, garlic and extra virgin olive oil" },
          { t: "Burrata con Prosciutto e Rucola", d: "Creamy burrata with thin prosciutto, rocket and a drizzle of balsamic glaze" },
          { t: "Arancini Siciliana", d: "Golden fried risotto balls filled with mozzarella, served with a rich tomato sauce" },
        ],
      },
      {
        title: "Primi — Pasta & First Courses",
        items: [
          { t: "Tagliatelle alla Bolognese", d: "Fresh egg pasta coated in a slow-cooked beef and tomato ragù" },
          { t: "Penne alla Vodka", d: "Penne in a creamy tomato and vodka sauce with parmesan and a hint of chilli" },
          { t: "Risotto ai Funghi Porcini", d: "Creamy arborio rice with porcini mushrooms, white wine and parmesan" },
        ],
      },
      {
        title: "Secondi — Main Courses",
        items: [
          { t: "Pollo alla Parmigiana", d: "Crispy breaded chicken with tomato sauce and melted mozzarella, roasted potatoes" },
          { t: "Branzino al Limone", d: "Oven-baked sea bass with lemon, garlic and herbs, sautéed greens" },
          { t: "Melanzane alla Parmigiana (Vegetarian)", d: "Layers of aubergine, tomato sauce, basil and parmesan baked until golden" },
        ],
      },
      {
        title: "Dolci — Desserts",
        items: [
          { t: "Tiramisu Classico" },
          { t: "Panna Cotta alla Vaniglia con Frutti di Bosco" },
          { t: "Cannoli Siciliani" },
        ],
      },
    ],
  },
  {
    id: "la-dolce-vita",
    name: "La Dolce Vita",
    sections: [
      {
        title: "Starters",
        items: [
          { t: "Burrata with Heirloom Tomatoes, Basil Pesto & Aged Balsamic" },
          { t: "Beef Carpaccio with Rocket, Parmesan & Truffle Dressing" },
          { t: "Crispy Truffle Arancini with Garlic Aioli" },
        ],
      },
      {
        title: "Main Courses",
        items: [
          { t: "Homemade Spinach & Ricotta Ravioli with Sage Butter" },
          { t: "Beef Fillet with Red Wine Reduction & Parmesan Potato Gratin" },
          { t: "Pan-Seared Sea Bass with Saffron Risotto & Lemon Beurre Blanc" },
        ],
      },
      {
        title: "Desserts",
        items: [
          { t: "Classic Tiramisu" },
          { t: "Pistachio Panna Cotta" },
          { t: "Limoncello Cheesecake" },
        ],
      },
    ],
  },
  {
    id: "mediterranean-bbq",
    name: "Mediterranean BBQ",
    sections: [
      {
        title: "Meats & Grill",
        items: [
          { t: "Moorish lamb skewers", d: "Marinated with ras el hanout, lemon and olive oil; finished with fresh mint" },
          { t: "Grilled chicken with lemon, garlic and oregano", d: "A Greek-inspired classic, tender and aromatic" },
          { t: "Iberian pork skewers with rosemary and orange-blossom honey", d: "Sweet, herbal and beautifully caramelised" },
          { t: "Mediterranean beef burgers", d: "Topped with feta, roasted tomato and toasted brioche" },
          { t: "Garlic–paprika grilled prawns", d: "With parsley and a splash of white wine" },
        ],
      },
      {
        title: "Side Dishes",
        items: [
          { t: "Heirloom tomato salad with kalamata olives and basil" },
          { t: "Classic tabbouleh with parsley, bulgur, mint and lemon" },
          { t: "Rosemary roasted potatoes with confit garlic" },
          { t: "Grilled courgette and aubergine with za'atar and lemon" },
          { t: "Seared halloumi with thyme honey and toasted pistachios" },
        ],
      },
      {
        title: "Breads & Extras",
        items: [
          { t: "Artisanal pita bread" },
          { t: "Mediterranean focaccia with rosemary and olives" },
          { t: "Seeded sourdough" },
          { t: "Marinated olives with citrus, garlic and herbs" },
        ],
      },
      {
        title: "Sauces & Condiments",
        items: [
          { t: "Creamy tzatziki" },
          { t: "Romesco sauce" },
          { t: "Lemon aioli" },
          { t: "Tahini–lemon sauce" },
          { t: "Mediterranean chimichurri" },
        ],
      },
    ],
  },
  {
    id: "parisian-elegance",
    name: "Parisian Elegance",
    sections: [
      {
        title: "Starters",
        items: [
          { t: "French Onion Soup with Gruyère Crouton" },
          { t: "Seared Scallops with Cauliflower Purée & Brown Butter" },
          { t: "Duck Rillettes with Cornichons & Toasted Brioche" },
        ],
      },
      {
        title: "Main Courses",
        items: [
          { t: "Beef Bourguignon with Creamy Potato Purée" },
          { t: "Duck Breast with Cherry Sauce & Potato Gratin" },
          { t: "Herb-Crusted Sea Bass with Ratatouille & Beurre Blanc" },
        ],
      },
      {
        title: "Desserts",
        items: [
          { t: "Crème Brûlée" },
          { t: "Chocolate Fondant with Vanilla Ice Cream" },
          { t: "Tarte Tatin with Salted Caramel" },
        ],
      },
    ],
  },
  {
    id: "sunday-roast",
    name: "Sunday Roast",
    sections: [
      {
        title: "Starters",
        items: [
          { t: "Leek and Potato Soup", d: "Creamy soup of leeks, potatoes, onions and cream, served with crusty bread" },
          { t: "Prawn Cocktail", d: "Cold-water prawns in Marie Rose sauce on shredded lettuce, cucumber and tomatoes" },
          { t: "Black Pudding & Sausage Scotch Egg with Mustard-Honey Sauce", d: "Soft-boiled egg wrapped in black pudding and Lincolnshire sausage, breadcrumbed" },
        ],
      },
      {
        title: "Main Course",
        items: [
          { t: "Traditional Roast — choose your meat", d: "Roast Beef · Roast Chicken · Roast Pork · Nut-Roast" },
          { t: "All served with", d: "Roast potatoes (duck fat or oil), seasonal vegetables, red wine gravy and Yorkshire puddings" },
        ],
      },
      {
        title: "Desserts",
        items: [
          { t: "Sticky Toffee Pudding", d: "Warm date sponge with toffee sauce and custard or vanilla ice cream" },
          { t: "Treacle Tart", d: "Shortcrust pastry with golden syrup, breadcrumbs and lemon zest, served with custard" },
          { t: "Warm Chocolate Brownie with Vanilla Ice Cream" },
        ],
      },
    ],
  },
  {
    id: "tapas-sharing",
    name: "Tapas Menu — Sharing",
    sections: [
      {
        title: "Sharing Plates",
        items: [
          { t: "Gambas al Ajillo", d: "Garlic prawns cooked in olive oil with garlic and fresh chilli" },
          { t: "Calamares Fritos", d: "Battered fresh squid" },
          { t: "Patatas Bravas", d: "Fried cubed potatoes with spicy tomato sauce" },
          { t: "Pimientos Verdes de Padrón", d: "Small green peppers with garlic" },
          { t: "Berenjena Rebozada con Miel", d: "Battered aubergine with honey and balsamic vinegar" },
          { t: "Chorizo a la Sidra", d: "Honey-glazed chorizo cooked in cider with spring onions and chilli" },
          { t: "Paella de Marisco", d: "Paella with seafood, green beans and chicken" },
          { t: "Cerdo en Salsa", d: "Slow-cooked pork in beer" },
          { t: "Croquetas de Jamón", d: "Deep-fried Iberian serrano ham croquettes in béchamel" },
          { t: "Albóndigas con Tomate", d: "Meatballs with herbs in a rich tomato sauce (gf)" },
        ],
      },
      {
        title: "Desserts",
        items: [
          { t: "Crema Catalana with Fresh Strawberries & Home-made Shortbread" },
        ],
      },
    ],
  },
  {
    id: "tasting-menu",
    name: "Tasting Menu",
    sections: [
      {
        title: "Amuse-Bouche",
        items: [
          { t: "Mini Bell Peppers Stuffed with Spinach & Cheese", d: "Sweet baby peppers filled with a creamy spinach-and-cheese mixture, finished with a light béchamel" },
        ],
      },
      {
        title: "Soup Course",
        items: [
          { t: "Butternut Squash Soup with Cheese Swirl", d: "Velvety roasted butternut squash soup with a gentle swirl of creamy cheese" },
        ],
      },
      {
        title: "Vegetable Course",
        items: [
          { t: "Sautéed Broccolini with Garlic & Lemon", d: "Tender broccolini finished with a squeeze of fresh lemon" },
        ],
      },
      {
        title: "Fish Course",
        items: [
          { t: "Oven-Baked Cod with Lemon Butter Sauce", d: "Flaky cod baked until tender in a delicate lemon butter sauce" },
        ],
      },
      {
        title: "Palate Cleanser",
        items: [
          { t: "Lemon or Green Apple Sorbet" },
        ],
      },
      {
        title: "Main Course",
        items: [
          { t: "Classic Beef Wellington", d: "Prime beef fillet in mushroom duxelles, wrapped in golden puff pastry, with seasonal vegetables and a rich jus" },
        ],
      },
      {
        title: "Desserts",
        items: [
          { t: "Mini Salted Caramel Tart" },
          { t: "Individual Chocolate Brownie" },
        ],
      },
    ],
  },
  {
    id: "the-english-table",
    name: "The English Table",
    sections: [
      {
        title: "Starters",
        items: [
          { t: "Smoked Scottish Salmon with Dill Crème Fraîche & Pickled Cucumber" },
          { t: "Creamy Wild Mushroom Soup with Truffle Oil & Sourdough Croutons" },
          { t: "Goat's Cheese Tart with Caramelised Onion & Rocket Salad" },
        ],
      },
      {
        title: "Main Courses",
        items: [
          { t: "Beef Wellington with Dauphinoise Potatoes, Seasonal Vegetables & Red Wine Jus" },
          { t: "Herb-Roasted Chicken Supreme with Buttered Greens & Fondant Potato" },
          { t: "Pan-Seared Cod with Crushed New Potatoes, Peas & Lemon Butter Sauce" },
        ],
      },
      {
        title: "Desserts",
        items: [
          { t: "Sticky Toffee Pudding with Vanilla Ice Cream" },
          { t: "Eton Mess with Fresh Berries" },
          { t: "Classic Lemon Posset with Shortbread" },
        ],
      },
    ],
  },
  {
    id: "vegetarian",
    name: "Vegetarian",
    sections: [
      {
        title: "Starters",
        items: [
          { t: "Garden Pea & Mint Soup", d: "Fresh, vibrant and smooth" },
          { t: "Beetroot & Goat Cheese Salad", d: "Roasted or pickled beets with goat cheese, rocket and walnuts" },
          { t: "Mini Leek & Potato Tartlets", d: "Crispy pastry shells with a creamy leek and potato filling" },
        ],
      },
      {
        title: "Mains",
        items: [
          { t: "Vegetable Wellington with Red Wine Gravy", d: "Puff pastry wrapped around roasted root veg and lentils" },
          { t: "Cauliflower Steak with Herb Butter & Crispy Topping", d: "Roasted golden with a crunchy breadcrumb topping, light cheese glaze and parsley" },
          { t: "Stuffed Marrow with Herby Couscous", d: "Baked marrow filled with couscous, tomatoes and pine nuts" },
        ],
      },
      {
        title: "Desserts",
        items: [
          { t: "Eton Mess", d: "Crushed meringue, whipped cream and strawberries" },
          { t: "Sticky Toffee Pudding", d: "Rich date sponge with toffee sauce" },
          { t: "Lemon Posset with Shortbread", d: "Creamy lemon custard" },
        ],
      },
    ],
  },
];

// Spanish mirror of MENUS — same ids, translated names/sections/descriptions.
export const MENUS_ES = [
  {
    id: "flavours-of-spain",
    name: "Sabores de España",
    sections: [
      {
        title: "Entrantes",
        items: [
          { t: "Jamón Ibérico con Pan con Tomate" },
          { t: "Gambas al Ajillo" },
          { t: "Gazpacho Andaluz con Pepino y Aceite de Oliva" },
        ],
      },
      {
        title: "Platos Principales",
        items: [
          { t: "Carrilleras de Cerdo Ibérico a Fuego Lento con Puré de Patata y Trufa" },
          { t: "Lubina a la Plancha con Patatas al Azafrán y Verduras de Temporada" },
          { t: "Paella de Marisco con Gambones, Mejillones y Calamares" },
        ],
      },
      {
        title: "Postres",
        items: [
          { t: "Tarta de Queso Vasca Quemada" },
          { t: "Torrija Tradicional con Helado de Vainilla" },
          { t: "Crema Catalana" },
        ],
      },
    ],
  },
  {
    id: "canape-party",
    name: "Fiesta de Canapés",
    sections: [
      {
        title: "Canapés",
        items: [
          { t: "Mousse de Salmón Ahumado con Crème Fraîche, Lima y Eneldo sobre Blini" },
          { t: "Paté de Stilton y Membrillo sobre Pan de Masa Madre" },
          { t: "Mini Canapés de Yorkshire Pudding con Crema de Rábano Picante" },
        ],
      },
      {
        title: "Entrantes",
        items: [
          { t: "Mejillones con Bacon Ahumado en Salsa Cremosa de Vino Blanco" },
          { t: "Gambas al Ajillo con Picatostes" },
          { t: "Sopa Cremosa de Marisco (Chowder)" },
        ],
      },
      {
        title: "Platos Principales",
        items: [
          { t: "Solomillo Wellington con Reducción de Vino Tinto Protos", d: "Acompañado de patatas nuevas machacadas con ajo y cebollino, brócoli tierno y zanahorias Chantenay" },
          { t: "Roulade de Pierna de Cordero con Jugo de Romero", d: "Acompañado de patatas asadas, judías verdes y calabacín salteado" },
          { t: "Salmón Glaseado con Miel y Ajo", d: "Acompañado de brócoli tierno, patatas nuevas y una ligera salsa de mantequilla al limón" },
        ],
      },
      {
        title: "Postres",
        items: [
          { t: "Crème Brûlée de Vainilla" },
          { t: "Panna Cotta de Fresa" },
          { t: "Tarta de Queso con Arándanos" },
        ],
      },
    ],
  },
  {
    id: "classic-british-bbq",
    name: "Barbacoa Británica Clásica",
    sections: [
      {
        title: "Carnes y Parrilla",
        items: [
          { t: "Salchichas Cumberland, Lincolnshire o de cerdo y manzana" },
          { t: "Hamburguesas de ternera con cheddar curado, cebolla caramelizada y pan brioche" },
          { t: "Muslos de pollo con miel y mostaza" },
          { t: "Chuletas de cerdo glaseadas con sidra y romero" },
          { t: "Brochetas de cordero con menta y yogur" },
        ],
      },
      {
        title: "Guarniciones",
        items: [
          { t: "Ensalada de col (col y zanahoria rallada con mayonesa cremosa)" },
          { t: "Ensalada de patata con cebollino y huevo cocido" },
          { t: "Alubias al horno (dulces y ahumadas)" },
          { t: "Halloumi a la parrilla con tomates cherry" },
          { t: "Ensalada de hojas variadas con vinagreta de mostaza inglesa" },
        ],
      },
      {
        title: "Panes y Extras",
        items: [
          { t: "Panes de hamburguesa y perrito" },
          { t: "Pan de cebolla o focaccia estilo británico" },
          { t: "Encurtidos, chutneys y cebollitas en vinagre" },
        ],
      },
      {
        title: "Salsas y Condimentos",
        items: [
          { t: "Salsa marrón estilo HP" },
          { t: "Mostaza inglesa (fuerte y picante)" },
          { t: "Ketchup y mayonesa" },
          { t: "Salsa BBQ ahumada" },
          { t: "Salsa de yogur y menta" },
        ],
      },
    ],
  },
  {
    id: "grazing-table",
    name: "Mesa de Picoteo — Fusión Británica y Mediterránea",
    sections: [
      {
        title: "Selección de Quesos y Embutidos",
        items: [
          { t: "Quesos Británicos", d: "Cheddar curado, Stilton, Brie de Somerset" },
          { t: "Quesos Mediterráneos", d: "Manchego, bocados de halloumi, feta marinada con hierbas y aceite de oliva" },
          { t: "Embutidos", d: "Jamón Serrano, Prosciutto di Parma, Chorizo Ibérico, Salami Milano" },
          { t: "Servido con", d: "Dulce de membrillo, uvas, higos, pepinillos y frutos secos variados" },
        ],
      },
      {
        title: "Panes y Dips",
        items: [
          { t: "Panes artesanos", d: "Focaccia, grissini, crackers de semillas, mini panes pita" },
          { t: "Hummus con pimentón y aceite de oliva" },
          { t: "Romesco de pimiento rojo asado y almendra" },
          { t: "Paté de caballa ahumada estilo británico" },
          { t: "Tzatziki con pepino y eneldo" },
        ],
      },
      {
        title: "Selección de Marisco",
        items: [
          { t: "Gambones con alioli de limón" },
          { t: "Salmón ahumado con alcaparras y chalotas sobre tostas de centeno" },
          { t: "Mini tartaletas de cangrejo con crème fraîche cítrica" },
          { t: "Anchoas marinadas y aceitunas con ralladura de naranja" },
        ],
      },
      {
        title: "Bocados Vegetarianos y Frescos",
        items: [
          { t: "Verduras mediterráneas asadas (calabacín, pimiento, berenjena)" },
          { t: "Brochetas de tomate cherry, mozzarella y albahaca" },
          { t: "Alcachofas marinadas y tomates secos" },
          { t: "Mini falafel con salsa de tahini" },
          { t: "Crudités de temporada: zanahoria, pepino, apio, rábano" },
        ],
      },
      {
        title: "Bocados de Carne y Salados",
        items: [
          { t: "Mini Yorkshire puddings con roast beef y crema de rábano picante" },
          { t: "Koftas de cordero con yogur de menta" },
          { t: "Brochetas de pollo con glaseado de limón y orégano" },
          { t: "Hojaldres de salchicha con chutney de cebolla caramelizada" },
        ],
      },
      {
        title: "Rincón Dulce",
        items: [
          { t: "Mini scones con clotted cream y mermelada" },
          { t: "Bocados de bizcocho de limón (lemon drizzle)" },
          { t: "Bizcocho de almendra mediterráneo (estilo Tarta de Santiago)" },
          { t: "Trufas de chocolate con sal marina" },
          { t: "Bandeja de fruta fresca: uvas, frutos rojos, melón, higos" },
        ],
      },
    ],
  },
  {
    id: "italian-4-course",
    name: "Menú Italiano de 4 Platos",
    sections: [
      {
        title: "Antipasti — Entrantes",
        items: [
          { t: "Bruschetta al Pomodoro", d: "Pan rústico tostado con tomates maduros, albahaca, ajo y aceite de oliva virgen extra" },
          { t: "Burrata con Prosciutto e Rucola", d: "Burrata cremosa con prosciutto fino, rúcula y un toque de glaseado balsámico" },
          { t: "Arancini Siciliana", d: "Bolas de risotto doradas rellenas de mozzarella, servidas con una rica salsa de tomate" },
        ],
      },
      {
        title: "Primi — Pasta y Primeros Platos",
        items: [
          { t: "Tagliatelle alla Bolognese", d: "Pasta fresca al huevo envuelta en ragú de ternera y tomate cocido a fuego lento" },
          { t: "Penne alla Vodka", d: "Penne en salsa cremosa de tomate y vodka con parmesano y un toque de guindilla" },
          { t: "Risotto ai Funghi Porcini", d: "Arroz arborio cremoso con setas porcini, vino blanco y parmesano" },
        ],
      },
      {
        title: "Secondi — Platos Principales",
        items: [
          { t: "Pollo alla Parmigiana", d: "Pollo empanado crujiente con salsa de tomate y mozzarella fundida, con patatas asadas" },
          { t: "Branzino al Limone", d: "Lubina al horno con limón, ajo y hierbas, con verduras salteadas" },
          { t: "Melanzane alla Parmigiana (Vegetariano)", d: "Capas de berenjena, salsa de tomate, albahaca y parmesano horneadas hasta dorar" },
        ],
      },
      {
        title: "Dolci — Postres",
        items: [
          { t: "Tiramisu Classico" },
          { t: "Panna Cotta alla Vaniglia con Frutti di Bosco" },
          { t: "Cannoli Siciliani" },
        ],
      },
    ],
  },
  {
    id: "la-dolce-vita",
    name: "La Dolce Vita",
    sections: [
      {
        title: "Entrantes",
        items: [
          { t: "Burrata con Tomates Heirloom, Pesto de Albahaca y Balsámico Añejo" },
          { t: "Carpaccio de Ternera con Rúcula, Parmesano y Aliño de Trufa" },
          { t: "Arancini de Trufa Crujientes con Alioli de Ajo" },
        ],
      },
      {
        title: "Platos Principales",
        items: [
          { t: "Ravioli Caseros de Espinaca y Ricotta con Mantequilla de Salvia" },
          { t: "Solomillo de Ternera con Reducción de Vino Tinto y Gratinado de Patata al Parmesano" },
          { t: "Lubina a la Plancha con Risotto al Azafrán y Beurre Blanc de Limón" },
        ],
      },
      {
        title: "Postres",
        items: [
          { t: "Tiramisú Clásico" },
          { t: "Panna Cotta de Pistacho" },
          { t: "Tarta de Queso al Limoncello" },
        ],
      },
    ],
  },
  {
    id: "mediterranean-bbq",
    name: "Barbacoa Mediterránea",
    sections: [
      {
        title: "Carnes y Parrilla",
        items: [
          { t: "Brochetas de cordero morunas", d: "Marinadas con ras el hanout, limón y aceite de oliva; terminadas con menta fresca" },
          { t: "Pollo a la parrilla con limón, ajo y orégano", d: "Un clásico de inspiración griega, tierno y aromático" },
          { t: "Brochetas de cerdo ibérico con romero y miel de azahar", d: "Dulces, herbáceas y bellamente caramelizadas" },
          { t: "Hamburguesas de ternera mediterráneas", d: "Con feta, tomate asado y brioche tostado" },
          { t: "Gambas a la parrilla con ajo y pimentón", d: "Con perejil y un chorrito de vino blanco" },
        ],
      },
      {
        title: "Guarniciones",
        items: [
          { t: "Ensalada de tomates heirloom con aceitunas kalamata y albahaca" },
          { t: "Tabulé clásico con perejil, bulgur, menta y limón" },
          { t: "Patatas asadas al romero con ajo confitado" },
          { t: "Calabacín y berenjena a la parrilla con za'atar y limón" },
          { t: "Halloumi a la plancha con miel de tomillo y pistachos tostados" },
        ],
      },
      {
        title: "Panes y Extras",
        items: [
          { t: "Pan pita artesanal" },
          { t: "Focaccia mediterránea con romero y aceitunas" },
          { t: "Pan de masa madre con semillas" },
          { t: "Aceitunas marinadas con cítricos, ajo y hierbas" },
        ],
      },
      {
        title: "Salsas y Condimentos",
        items: [
          { t: "Tzatziki cremoso" },
          { t: "Salsa romesco" },
          { t: "Alioli de limón" },
          { t: "Salsa de tahini y limón" },
          { t: "Chimichurri mediterráneo" },
        ],
      },
    ],
  },
  {
    id: "parisian-elegance",
    name: "Elegancia Parisina",
    sections: [
      {
        title: "Entrantes",
        items: [
          { t: "Sopa de Cebolla Francesa con Picatoste de Gruyère" },
          { t: "Vieiras Salteadas con Puré de Coliflor y Mantequilla Noisette" },
          { t: "Rillettes de Pato con Pepinillos y Brioche Tostado" },
        ],
      },
      {
        title: "Platos Principales",
        items: [
          { t: "Boeuf Bourguignon con Puré de Patata Cremoso" },
          { t: "Magret de Pato con Salsa de Cerezas y Gratinado de Patata" },
          { t: "Lubina en Costra de Hierbas con Ratatouille y Beurre Blanc" },
        ],
      },
      {
        title: "Postres",
        items: [
          { t: "Crème Brûlée" },
          { t: "Coulant de Chocolate con Helado de Vainilla" },
          { t: "Tarta Tatin con Caramelo Salado" },
        ],
      },
    ],
  },
  {
    id: "sunday-roast",
    name: "Asado Dominical (Sunday Roast)",
    sections: [
      {
        title: "Entrantes",
        items: [
          { t: "Sopa de Puerro y Patata", d: "Sopa cremosa de puerros, patatas, cebolla y nata, servida con pan de corteza" },
          { t: "Cóctel de Gambas", d: "Gambas de agua fría en salsa Marie Rose sobre lechuga rallada, pepino y tomate" },
          { t: "Scotch Egg de Morcilla y Salchicha con Salsa de Mostaza y Miel", d: "Huevo poco hecho envuelto en morcilla y salchicha de Lincolnshire, empanado" },
        ],
      },
      {
        title: "Plato Principal",
        items: [
          { t: "Asado Tradicional — elige tu carne", d: "Ternera Asada · Pollo Asado · Cerdo Asado · Asado de Frutos Secos" },
          { t: "Todo servido con", d: "Patatas asadas (grasa de pato o aceite), verduras de temporada, gravy de vino tinto y Yorkshire puddings" },
        ],
      },
      {
        title: "Postres",
        items: [
          { t: "Sticky Toffee Pudding", d: "Bizcocho caliente de dátiles con salsa de toffee y natillas o helado de vainilla" },
          { t: "Treacle Tart", d: "Masa quebrada con sirope dorado, pan rallado y ralladura de limón, servida con natillas" },
          { t: "Brownie de Chocolate Caliente con Helado de Vainilla" },
        ],
      },
    ],
  },
  {
    id: "tapas-sharing",
    name: "Menú de Tapas — Para Compartir",
    sections: [
      {
        title: "Platos para Compartir",
        items: [
          { t: "Gambas al Ajillo", d: "Gambas cocinadas en aceite de oliva con ajo y guindilla fresca" },
          { t: "Calamares Fritos", d: "Calamar fresco rebozado" },
          { t: "Patatas Bravas", d: "Patatas fritas en cubos con salsa brava" },
          { t: "Pimientos Verdes de Padrón", d: "Pimientos verdes pequeños con ajo" },
          { t: "Berenjena Rebozada con Miel", d: "Berenjena rebozada con miel y vinagre balsámico" },
          { t: "Chorizo a la Sidra", d: "Chorizo glaseado con miel cocido en sidra con cebolletas y guindilla" },
          { t: "Paella de Marisco", d: "Paella con marisco, judías verdes y pollo" },
          { t: "Cerdo en Salsa", d: "Cerdo cocido a fuego lento en cerveza" },
          { t: "Croquetas de Jamón", d: "Croquetas de jamón serrano ibérico en bechamel" },
          { t: "Albóndigas con Tomate", d: "Albóndigas con hierbas en una rica salsa de tomate (sg)" },
        ],
      },
      {
        title: "Postres",
        items: [
          { t: "Crema Catalana con Fresas Frescas y Shortbread Casero" },
        ],
      },
    ],
  },
  {
    id: "tasting-menu",
    name: "Menú Degustación",
    sections: [
      {
        title: "Amuse-Bouche",
        items: [
          { t: "Mini Pimientos Rellenos de Espinaca y Queso", d: "Pimientos dulces baby rellenos de una cremosa mezcla de espinaca y queso, terminados con una ligera bechamel" },
        ],
      },
      {
        title: "Sopa",
        items: [
          { t: "Crema de Calabaza con Espiral de Queso", d: "Aterciopelada crema de calabaza asada con un suave espiral de queso cremoso" },
        ],
      },
      {
        title: "Plato de Verduras",
        items: [
          { t: "Bimi Salteado con Ajo y Limón", d: "Bimi tierno terminado con un chorro de limón fresco" },
        ],
      },
      {
        title: "Plato de Pescado",
        items: [
          { t: "Bacalao al Horno con Salsa de Mantequilla al Limón", d: "Bacalao jugoso horneado en una delicada salsa de mantequilla y limón" },
        ],
      },
      {
        title: "Limpiapaladar",
        items: [
          { t: "Sorbete de Limón o Manzana Verde" },
        ],
      },
      {
        title: "Plato Principal",
        items: [
          { t: "Solomillo Wellington Clásico", d: "Solomillo de ternera en duxelles de setas, envuelto en hojaldre dorado, con verduras de temporada y un rico jus" },
        ],
      },
      {
        title: "Postres",
        items: [
          { t: "Mini Tarta de Caramelo Salado" },
          { t: "Brownie de Chocolate Individual" },
        ],
      },
    ],
  },
  {
    id: "the-english-table",
    name: "La Mesa Inglesa",
    sections: [
      {
        title: "Entrantes",
        items: [
          { t: "Salmón Escocés Ahumado con Crème Fraîche de Eneldo y Pepino en Vinagre" },
          { t: "Sopa Cremosa de Setas Silvestres con Aceite de Trufa y Picatostes de Masa Madre" },
          { t: "Tarta de Queso de Cabra con Cebolla Caramelizada y Ensalada de Rúcula" },
        ],
      },
      {
        title: "Platos Principales",
        items: [
          { t: "Solomillo Wellington con Patatas Dauphinoise, Verduras de Temporada y Jus de Vino Tinto" },
          { t: "Suprema de Pollo al Horno con Hierbas, Verduras con Mantequilla y Patata Fondant" },
          { t: "Bacalao a la Plancha con Patatas Nuevas Machacadas, Guisantes y Salsa de Mantequilla al Limón" },
        ],
      },
      {
        title: "Postres",
        items: [
          { t: "Sticky Toffee Pudding con Helado de Vainilla" },
          { t: "Eton Mess con Frutos Rojos Frescos" },
          { t: "Lemon Posset Clásico con Shortbread" },
        ],
      },
    ],
  },
  {
    id: "vegetarian",
    name: "Vegetariano",
    sections: [
      {
        title: "Entrantes",
        items: [
          { t: "Crema de Guisantes y Menta", d: "Fresca, vibrante y suave" },
          { t: "Ensalada de Remolacha y Queso de Cabra", d: "Remolacha asada o encurtida con queso de cabra, rúcula y nueces" },
          { t: "Mini Tartaletas de Puerro y Patata", d: "Crujientes cestas de hojaldre con un cremoso relleno de puerro y patata" },
        ],
      },
      {
        title: "Platos Principales",
        items: [
          { t: "Wellington de Verduras con Gravy de Vino Tinto", d: "Hojaldre envolviendo verduras de raíz asadas y lentejas" },
          { t: "Filete de Coliflor con Mantequilla de Hierbas y Cobertura Crujiente", d: "Asado dorado con cobertura crujiente de pan rallado, ligero glaseado de queso y perejil" },
          { t: "Calabacín Relleno con Cuscús de Hierbas", d: "Calabacín al horno relleno de cuscús, tomates y piñones" },
        ],
      },
      {
        title: "Postres",
        items: [
          { t: "Eton Mess", d: "Merengue triturado, nata montada y fresas" },
          { t: "Sticky Toffee Pudding", d: "Rico bizcocho de dátiles con salsa de toffee" },
          { t: "Lemon Posset con Shortbread", d: "Cremosa crema de limón" },
        ],
      },
    ],
  },
];
